// styles
import styled from "styled-components";

const BranchItemStyles = styled.div`
  padding: ${({ theme }) => theme.spacing[20]};
  margin: 0 8px 4px 8px;

  &:first-child {
    margin-top: 8px;
  }

  &:last-child {
    margin-bottom: 8px;
  }
  background: transparent;
  position: relative;
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.accent[50]};
  }

  ${({ $isActive, theme }) => $isActive && `
    background: ${theme.colors.accent[50]};

    &::before {
      content: '';
      position: absolute;
      left: 8px;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 50%;
      background: ${theme.colors.accent[500]};
      border-radius: 2px;
    }
  `}

  .branchName {
    font-style: normal;
    font-weight: 600;
    font-size: ${({ theme }) => theme.typography.body.b2.size};
    line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
    letter-spacing: 0.1px;
    color: ${({ $isActive, theme }) =>
      $isActive ? theme.colors.accent[500] : theme.colors.semantic.text.strong};
  }

  .branchDetails {
    font-style: normal;
    font-weight: ${({ theme }) => theme.typography.title.t2.weight};
    font-size: 10px;
    line-height: ${({ theme }) => theme.typography.title.t3.lineHeight};
    letter-spacing: 0.1px;
    color: ${({ $isActive, theme }) => $isActive ? theme.colors.accent[300] : theme.colors.semantic.text.weak};
    margin-top: ${({ theme }) => theme.spacing[4]};
  }
`;

const BranchItem = ({ name, location, isActive, onClick }) => {
  return (
    <BranchItemStyles onClick={onClick} $isActive={isActive}>
      <h4 className="branchName">{name}</h4>
      <p className="branchDetails">{location.address}</p>
    </BranchItemStyles>
  );
};

export default BranchItem;
